document.addEventListener("DOMContentLoaded", () => {

  // Run only on products tagged "Premium Printshield Case"
  if (!window.isPhoneCase) return;

  const images = document.querySelectorAll(".product__media img");

if (images.length < 2) return;

const previewImage = images[0]; // design only
const mockupImage = images[1];  // iPhone 16 pro mockup
if (!previewImage || !mockupImage) return;

// Cache the second thumbnail button once
const secondThumbnailButton = document.querySelector(
  '.thumbnail-list__item[data-media-position="2"] button'
);

const frame = document.createElement("img");
frame.className = "cc-frame-overlay";
mockupImage.parentElement.appendChild(frame);

  // Default preview
  frame.src = window.phoneFrames["iphone-16-pro"];
  frame.classList.add("active");
 
  // Default state
previewImage.style.display = "";
mockupImage.style.display = "none";

  let previousDetectedKey = null;

  function updateFrame() {

  let detectedKey = previousDetectedKey;

// Find ALL checked Globo dropdown radios
const selectedOptions = document.querySelectorAll(
  'input[data-type="dropdown"]:checked'
);

selectedOptions.forEach(option => {

  const key = option.value
    .trim()
    .toLowerCase()
    .replace(/\s+/g, "-");

  // Detect even if the frame image doesn't exist yet
  if (Object.prototype.hasOwnProperty.call(window.phoneFrames, key)) {
    detectedKey = key;
  }

});

  if (!detectedKey) {
    previewImage.style.display = "";
    mockupImage.style.display = "none";
    previousDetectedKey = null;
    return;
  }

  // Switch gallery only when model changes
  if (previousDetectedKey !== detectedKey) {

    previousDetectedKey = detectedKey;

    setTimeout(() => {
  secondThumbnailButton?.click();
}, 100);

  }

  previewImage.style.display = "none";
  mockupImage.style.display = "";

  const newSrc = window.phoneFrames[detectedKey];

// If this model doesn't have a frame yet,
// keep showing the previous one instead of disappearing.
if (!newSrc) return;

if (frame.dataset.currentFrame === newSrc) return;

frame.dataset.currentFrame = newSrc;

frame.classList.remove("active");

setTimeout(() => {
  frame.src = newSrc;
  frame.classList.add("active");
}, 50);

}

  // Run once on page load
updateFrame();

// Listen for Globo dropdown changes
document.addEventListener("change", (e) => {

  if (!e.target.matches('input[data-type="dropdown"]')) return;

  setTimeout(updateFrame, 50);

});

});

function updateCartFrames() {

  document.querySelectorAll("[data-cart-item]").forEach(item => {

    const frame = item.querySelector("[data-cart-frame]");
    if (!frame) return;

    let detectedKey = null;

    item.querySelectorAll("dl .product-option").forEach(option => {

      const text = option.textContent
        .trim()
        .toLowerCase();

      Object.keys(window.phoneFrames).forEach(key => {

        const readableKey = key
          .replace(/-/g, " ")
          .trim();

        // Match the model as a complete value/word,
        // so "iphone 17" does NOT match "iphone 17e"
        // and "nothing phone 2" does NOT match "nothing phone 2a".
        const escapedKey = readableKey.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");

        const regex = new RegExp(
          "(^|\\s|:)" + escapedKey + "(?=\\s|$|\\n|:)",
          "i"
        );

        if (regex.test(text)) {
          detectedKey = key;
        }

      });

    });

    if (!detectedKey) {

      const firstThumb = document.querySelector(
        '.thumbnail-list__item[data-media-position="1"] button'
      );

      if (firstThumb && !firstThumb.getAttribute("aria-current")) {
        firstThumb.click();
      }

      return;
    }

    // Keep your existing second-image selection
    const secondSlideButton = document.querySelector(
      '[data-media-id]:not([data-media-id="' +
      document.querySelector(".product__media-toggle")?.dataset.mediaId +
      '"])'
    );

    if (secondSlideButton) {
      secondSlideButton.click();
    }

    const frameUrl = window.phoneFrames[detectedKey];

    if (!frameUrl) return;

    frame.src = frameUrl;

  });

}

document.addEventListener("DOMContentLoaded", updateCartFrames);

const cartDrawer = document.getElementById("CartDrawer");

if (cartDrawer) {

  let updateTimer;

  new MutationObserver(() => {

    clearTimeout(updateTimer);

    updateTimer = setTimeout(() => {
      updateCartFrames();
    }, 100);

  }).observe(cartDrawer, {
    childList: true,
    subtree: true
  });

}